export default function Close({ width, height, fillColour }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width={width} height={height}>
      <path
        fill={fillColour}
        d="M3.85 3.15a.5.5 0 0 0-.707.707l2.15 2.15l-2.15 2.15a.5.5 0 0 0 .707.707L6 6.714l2.15 2.15a.5.5 0 0 0 .707-.707l-2.15-2.15l2.15-2.15a.5.5 0 0 0-.707-.707L6 5.3z"
      />
    </svg>
  );
}
